import tinycolor2 from 'tinycolor2';
import type { Attributes } from './Wrapper';

type ClassNameProps = Attributes;

const PREFIX = 'band';

export const getClassName = ({
  spacing = 'large',
  contentAlignment,
  background,
  transforms,
  contained,
  outline,
}: ClassNameProps) => {
  const classNames = [`${PREFIX}-wrapper`];

  const tc = tinycolor2(background);

  const hasColor = tc.toHexString() !== '#ffffff';
  const isDarkBackround = tc.isDark();

  classNames.push(hasColor ? `${PREFIX}--color` : `${PREFIX}--white`);

  if (isDarkBackround) {
    classNames.push(`${PREFIX}--dark-bg`);
  }

  // -- Spacing --
  if (spacing) {
    classNames.push(`${PREFIX}--${spacing.toLowerCase()}`);
  }

  // -- Contained --
  classNames.push(contained ? `${PREFIX}--contained` : `${PREFIX}--not-contained`);

  // -- Outline --
  if (outline) {
    classNames.push(`${PREFIX}--outline`);
  }

  // -- Content Alignment --
  if (contentAlignment) {
    classNames.push(`${PREFIX}--${contentAlignment.toLowerCase()}`);
  }

  // -- Transforms --
  if (transforms) {
    transforms.map((transform) => classNames.push(transform.toLowerCase()));
  }

  return classNames.join(' ');
};
